import React from 'react'
import { Alert, Checkbox, FormControlLabel, FormGroup } from '@mui/material'
import LoadingDefault from '@/Components/Elements/Loading/LoadingDefault'
import DefaultSearchbar from '@/Components/Elements/Search/DefaultSearchbar'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
import { ExportFieldsTableProps } from '../types'

export default function ExportFieldsTable(props: ExportFieldsTableProps) {
    const {
        kedo,
        fields,
        metaFields,
        selectedFields,
        loading,
        fileType,
        removeHtml,
        onToggleRemoveHtml,
        selectAllFields,
        searchValue,
        handleFilterChange,
        handleSearchFields,
        resetButtonFields,
        renderItemsId,
        getItemMode,
        onChangeFields
    } = props

    const allSelected =
        selectedFields.length ===
        (fields?.length || 0) + (metaFields?.length || 0)

    return (
        <FormGroup className="table-responsive">
            {fileType === 'csv' && onToggleRemoveHtml && (
                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={removeHtml}
                            name="removeHtml"
                            onChange={(e) =>
                                onToggleRemoveHtml(e.target.checked)
                            }
                        />
                    }
                    label={kedo.t(
                        'Would you like the HTML tags to be stripped from the CSV file?'
                    )}
                />
            )}

            <FormInputLabel>
                <h5>{kedo.t('Fields to export')}</h5>
            </FormInputLabel>

            <DefaultSearchbar
                kedo={kedo}
                handleChange={handleFilterChange}
                handleSearch={handleSearchFields}
                searchName={searchValue}
                resetButton={resetButtonFields}
            />

            {!loading && (!fields || fields.length <= 0) && (
                <Alert severity="warning">{kedo.t('No fields found')}</Alert>
            )}

            {loading ? (
                <LoadingDefault />
            ) : (
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={allSelected}
                                            onChange={selectAllFields}
                                        />
                                    }
                                    label={
                                        <strong>{kedo.t('Select all')}</strong>
                                    }
                                />
                            </th>
                            <th />
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((item) => (
                            <tr key={item.id}>
                                <td>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={
                                                    !!selectedFields.find(
                                                        (f) => f.id === item.id
                                                    )
                                                }
                                                onChange={onChangeFields}
                                                value={item.id}
                                            />
                                        }
                                        label={kedo.translateItem(
                                            item,
                                            'displayitem'
                                        )}
                                    />
                                </td>
                                <td>
                                    {item.def_dossier_link &&
                                        renderItemsId?.(item.id)}
                                </td>
                                <td>
                                    <small>{getItemMode?.(item)}</small>
                                </td>
                            </tr>
                        ))}

                        {metaFields.map((item) => (
                            <tr key={item.id}>
                                <td>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={
                                                    !!selectedFields.find(
                                                        (f) => f.id === item.id
                                                    )
                                                }
                                                onChange={onChangeFields}
                                                value={item.id}
                                            />
                                        }
                                        label={item.label}
                                    />
                                </td>
                                <td />
                                <td>
                                    <small>Metadata</small>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </FormGroup>
    )
}
